module.exports = ReactDOM;


/*****************
 ** WEBPACK FOOTER
 ** external "ReactDOM"
 ** module id = 3
 ** module chunks = 0 1 2
 **/